import User from "../models/user";
import environments from "../utils/environments";
import { ApiService } from "./api.service";

const API_URL = environments.apiUrl + "/api/auth";

class AuthService {
  rolesCache: string[] = [];
  userName: string = "";

  hasRole(role: string) {
    return ApiService.get(API_URL + "/role/" + role);
  }

  hasAnyRoleOf(roles: string[]) {
    return ApiService.post(API_URL + "/roles", {
      roles: roles,
    });
  }

  /**
   * Have to be used in early stage of entering the UI, so that AuthService.getRoles can be used properly
   */
  async loadRoles() {
    try {
      this.rolesCache = (await ApiService.get(API_URL + "/roles")).data;
    } catch (err) {
      const error = err as any;
      if (error.response && error.response.status === 401) {
        throw new Error("Nicht authentifiziert. Bitte erneut anmelden.");
      } else if (error.response && error.response.status === 403) {
        throw new Error("Zugriff verweigert. Sie haben keine Berechtigung, die Rollen abzurufen.");
      } else {
        const message = error.response ? error.response.data : "Unbekannter Fehler";
        throw new Error("Fehler beim Laden der Rollen: " + (message || "Unbekannter Fehler"));
      }
    }
  }

  /**
   * Important notes: 
   * - The roles have to be loaded first in order to be used. 
   * - This is currently done by AuthService.loadRoles, which is called in the created-Methode of App.vue to ensure all roles are properly loaded.
   * 
   * @returns all roles from backend
   */
  getRoles(): string[] {
    return this.rolesCache;
  }

  /**
   * Have to be used in early stage of entering the UI, so that AuthService.getRoles can be used properly
   */
  async loadUserName() {
    try {
      this.userName = (await ApiService.get(API_URL + "/me")).data;
    } catch (err) {
      const error = err as any;
      if (error.response && error.response.status === 401) {
        throw new Error("Nicht authentifiziert. Bitte erneut anmelden.");
      } else if (error.response && error.response.status === 403) {
        throw new Error("Zugriff verweigert. Sie haben keine Berechtigung, den Benutzernamen abzurufen.");
      } else {
        const message = error.response ? error.response.data : "Unbekannter Fehler";
        throw new Error("Fehler beim Laden des Benutzernamens: " + (message || "Unbekannter Fehler"));
      }
    }
  }

  /**
   * Important notes: 
   * - The roles have to be loaded first in order to be used. 
   * - This is currently done by AuthService.loadRoles, which is called in the created-Methode of App.vue to ensure all roles are properly loaded.
   * 
   * @returns all roles from backend
   */
  getUserName(): string {
    return this.userName;
  }
}

export default new AuthService();
